export const mdiChevronLeft = 'M15.41 16.58 10.83 12l4.58-4.59L14 6l-6 6 6 6z';